export const FilesToMediaPayload = (files: IFile[], collection: EMediaCollection, modelId: string | number) => {
	const form = new FormData()
	files.forEach((file, index) => {
		if (!file.media) throw new Error(`File at index ${index} is missing`)

		if (typeof file.order !== 'number') throw new Error(`Order at index ${index} is invalid`)

		form.append(`media[${index}][file]`, file.media)
		form.append(`media[${index}][order]`, (file.order + 1).toString())
	})

	form.append('collection_name', collection as string)
	form.append('entity_id', modelId as string)

	return form
}

export const FilesToMediaBulkPayload = (collectionOfFiles: Record<number, IFile[]>, collection: EMediaCollection) => {
	const form = new FormData()
	for (const [targetId, files] of Object.entries(collectionOfFiles)) {
		files.forEach((file, index) => {
			if (!file.media) throw new Error(`File at index ${index} is missing`)

			if (typeof file.order !== 'number') throw new Error(`Order at index ${index} is invalid`)

			form.append(`media[${index}][file]`, file.media)
			form.append(`media[${index}][collection_name]`, collection as string)
			form.append(`media[${index}][entity_id]`, targetId)
			form.append(`media[${index}][order]`, (file.order + 1).toString())
		})
	}

	return form
}
